import BaseView from './utilities/baseView.js';
import { tns } from "tiny-slider";
import SliderCounter from './utilities/slider-counter.js';
import ImgLazyLoader from "./utilities/imgLazyLoader.js";

class PromotionsView extends BaseView {
    sliderCounter = null;
    sliders = document.querySelectorAll('.object-slider');

    cssClass = {
        seeMoreContainer: 'see-more',
        active: 'active',
        link: 'link',
        linkSecondary: 'link--secondary',
    }

    constructor() {
        super(promotionsConfig);
        this.sliderCounter = new SliderCounter();
        this.lazyLoader = new ImgLazyLoader();
        this.preparePhotosSliders();
        this.prepareSeeMoreContainer();
        this.prepareObjectsLazyLoader();
    }

    preparePhotosSliders = () => {
        this.sliders.forEach(slider => {
            const tinySLider = tns({
                preventScrollOnTouch: 'force',
                container: slider,
                items: 1,
                nav: false,
                mouseDrag: true,
                center: false,
                controls: true,
                swipeAngle: false,
                arrowKeys: true
            });

            if (tinySLider !== undefined) {
                tinySLider.events.on('indexChanged', (data, eventName) => {
                    this.sliderCounter.add(data);
                });
            }
        });
    }

    prepareSeeMoreContainer = () => {
        const { cssClass, locale } = this;
        const container = document.querySelector(`.${cssClass.seeMoreContainer}`);

        if (container) {
            const button = document.createElement('span');
            button.classList.add(cssClass.link, cssClass.linkSecondary);
            button.innerText = locale("seeMore");

            button.addEventListener('click', () => {
                container.classList.toggle(cssClass.active);
                button.innerText = (container.classList.contains(cssClass.active)) ? locale("seeLess") : locale("seeMore");
            });

            container.parentElement.insertBefore(button, container.nextSibling);
        }
    }

    prepareObjectsLazyLoader = () => {
        const container = document.querySelector(".promotion__list");
        const objects = container.querySelectorAll(".object");
        const footer = document.querySelector('.footer');
        const toDisplay = [];

        objects.forEach((object, index) => {
            if (index > 7) {
                toDisplay.push(object.cloneNode(true));
                object.remove();
            }
        });

        window.addEventListener('scroll', () => {
            const footerRect = footer.getBoundingClientRect();

            if (window.innerHeight >= footerRect.top && toDisplay.length !== 0) {
                for (let index = 0; index < 4; index++) {
                    const object = toDisplay.pop();
                    if (object) {
                        container.appendChild(object);
                        this.lazyLoader.singleImageLoad(object.querySelector('.object-slider__item img'));
                    }
                }
            }
        });
    }
}

new PromotionsView();